// ID determinístico do slot de agendamento.
// Garante que check + write sejam atômicos via transaction: dois clientes tentando
// o mesmo slot ao mesmo tempo — apenas um consegue. O mesmo ID é usado como chave do
// doc de contato em `atendimentos_contato/{slotId}`.

// Normaliza: remove acentos e troca não-alfanuméricos por "_"
export function sanitize(s) {
  return (s || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-zA-Z0-9]/g, '_');
}

// Monta `barbeariaId_barbeiro_ano_mes_dia_horario`
export function buildSlotId({ barbeariaId, barbeiro, ano, mes, dia, horario }) {
  return [
    barbeariaId,
    sanitize(barbeiro),
    ano,
    sanitize(mes),
    dia,
    (horario || '').replace(':', 'h'),
  ].join('_');
}

const MESES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

// Instante de início do agendamento como Date (ou null se a data for inválida).
// Usa o ano salvo no doc quando presente; senão cai no ano de referência.
export function inicioAgendamento(a, refDate = new Date()) {
  const mi = MESES.indexOf(a?.mes || '');
  if (mi === -1) return null;
  const [hh, mm] = (a?.horario || '00:00').split(':').map(Number);
  const ano = a?.ano ? parseInt(a.ano) : refDate.getFullYear();
  const dt = new Date(ano, mi, parseInt(a?.dia || '0'), hh || 0, mm || 0, 0, 0);
  return isNaN(dt.getTime()) ? null : dt;
}

// Um agendamento pendente "expira" quando o horário agendado já começou:
// depois disso a barbearia não pode mais confirmar e o pedido deixa de valer.
export function isPendenteExpirado(a, agora = new Date()) {
  if (a?.status !== 'pendente') return false;
  const ini = inicioAgendamento(a, agora);
  return !!ini && ini.getTime() <= agora.getTime();
}
